module.exports = __webpack_public_path__ + "img/contact-icon.58daa3b5.png";